<template>
  <Modal :show="show" :showCancelButton="false" :showConfirmButton="false">
    <template #header>
      <div class="row">
        <h3 class="mb-4 mt-3 h3-ecommerce-green">
          {{ t("TO_GET_STARTED") }}
        </h3>
      </div>
    </template>
    <template #body>
      <div class="row align-items-center">
        <div class="col">
          {{ t("YOU_CAN_OPEN_THIS") }}
        </div>
      </div>
      <div class="row align-items-end" style="margin-top: 5px">
        <div class="col-7">
          <InputFieldText inputId="url" v-model="currentUrl" :readonly="true" />
        </div>
        <div class="col-5" style="text-align: center">
          <button
            class="btn btn-success"
            style="margin-bottom: 5px"
            @click="copyUrl"
          >
            {{ t("COPY") }}
            <i
              class="fa-solid mx-1"
              :class="{
                'fa-copy': !isUrlCopied,
                'fa-check': isUrlCopied,
              }"
            ></i>
          </button>
        </div>
      </div>
      <div
        :class="
          'row text-center alert alert-dismissible fade show alert-' + alertType
        "
        role="alert"
        v-show="showAlert"
        style="margin: 10px 0 0 0"
      >
        {{ alertMessage }}
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          @click="hideAlert()"
        ></button>
      </div>
      <div class="row align-items-center">
        <div class="col-12" style="display: flex; margin-top: 15px">
          <button
            class="btn btn-success"
            style="margin-bottom: 5px; flex-grow: 1"
            @click="openInChrome"
          >
            {{ t("OPEN_IN_GOOGLE_CHROME") }}
          </button>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "@/apps/merchant3/composables/useI18n";
import Modal from "@/apps/merchant3/shared-components/ui/Modal.vue";
import InputFieldText from "@/apps/merchant3/shared-components/input-fields/InputFieldText.vue";
import logEvent from "@/apps/merchant3/services/event-logs.service";
import EventLogs from "@/apps/merchant3/types/EventLogs";

interface Props {
  show: boolean;
  url?: string;
}

const props = withDefaults(defineProps<Props>(), {
  url: () => window.location.href,
});

const { t } = useI18n();

const currentUrl = ref(props.url);
const isUrlCopied = ref(false);
const showAlert = ref(false);
const alertType = ref("danger");
const alertMessage = ref("");

const copyUrl = async () => {
  try {
    await navigator.clipboard.writeText(currentUrl.value);
    isUrlCopied.value = true;
    logEvent(EventLogs.Events.BROWSER_REDIRECTION_POPUP_URL_COPIED);
    setTimeout(() => {
      isUrlCopied.value = false;
    }, 2000);
  } catch (error) {
    alertType.value = "danger";
    showAlert.value = true;
    alertMessage.value = t("COPY_ERROR");
  }
};

const openInChrome = () => {
  logEvent(EventLogs.Events.BROWSER_REDIRECTION_POPUP_BUTTON_CLICKED);
  window.location.href =
    "intent://" +
    currentUrl.value.replace(/^https?:\/\//, "") +
    "#Intent;scheme=https;package=com.android.chrome;end;";
};

const hideAlert = () => {
  showAlert.value = false;
};
</script>

<style lang="scss">
@import "@/assets/scss/_constants.scss";

.h3-ecommerce-green {
  font-size: 1.2rem;
  color: $pj-color-green;
}
</style>
